import React, { useState } from "react";
import styles from "./promotionCard.scss";
import QuantitySelector from "@tw/shared-ui-components/lib/components/quantitySelector/quantitySelector";
import CartBtn from "@tw/shared-ui-components/lib/components/addToCartButton/cartBtn";
import { ProductFlag } from "@tw/shared-ui-components/lib/components/productFlag/productFlag";
import {
  getProductStatus,
  getLoggedInUserInfo,
} from "../../../../common/utils/helper";
import NoTranslate from "../../../../common/components/notranslate/noTranslate";

function PromotionCard({
  product,
  onAddToCart,
  disableAddToCart,
  isWishlisted,
  toggleWishList,
  cartText,
  Link,
  quantity,
  onQuantityChange,
  displayAddToCart,
  displayQuantitySelector,
  CheckedPlp,
}) {
  const NextLink = Link || "a";
  const aboUserRoleIdentifier = "ABO";
  const loggedInUserRole = getLoggedInUserInfo().role;
  const intlNumberFormatter = new Intl.NumberFormat("en-US");

  const ReadMore = ({ children }) => {
    const text = children;
    const [isReadMore] = useState(true);

    let textChar = 39;
    return (
      <p className={styles["text"]}>
        {text &&
          text.length > textChar &&
          (isReadMore ? text.slice(0, textChar - 1) : text)}
        {text && text.length > textChar && (
          <span className={styles["read-or-hide"]}>...</span>
        )}
        {text && text.length <= textChar && text}
      </p>
    );
  };

  const isProductDisabled = ["upcoming", "outOfStock", "notForSale"].includes(
    product?.productStatus
  );
  const productStatus = getProductStatus(product);

  if (!product) {
    return null;
  }

  const onAddToCartHandle = () => {
    onAddToCart(product.itemCode, quantity);
  };

  const onWishlistHandle = () => {
    toggleWishList(product);
  };

  return (
    <div className={styles[`plp-main-div`]}>
      <div className={styles["plp-wrapper"]}>
        <div className={styles["image-box"]}>
          <div className={styles["plp-header"]}>
            <div className={styles["plp-flag"]}>
              <ProductFlag productFlags={product.labels} />
            </div>
            {CheckedPlp && (
              <div className={styles["plp-checkbox"]}>
                <CheckedPlp itemCode={product.itemCode} />
              </div>
            )}
          </div>
          <NextLink href={`/products/${product.itemCode}`}>
            <a>
              {product.image ? (
                <img
                  src={product.image}
                  className={styles["plp-product-img"]}
                  alt={product.skuName}
                />
              ) : null}
            </a>
          </NextLink>
          {productStatus ? (
            <p className={styles["out-of-stock-status"]}>
              {productStatus.label}
            </p>
          ) : null}
        </div>
        <div className={styles["detail-box"]}>
          <div className={styles["plp-heading"]}>
            <p>{product?.productBrand}</p>

            {loggedInUserRole !== aboUserRoleIdentifier ? (
              <WishlistedComp
                isWishlisted={isWishlisted}
                onWishlistHandle={onWishlistHandle}
              />
            ) : null}
          </div>

          <div className={styles["plp-product-details"]}>
            <div className={styles["plp-basic-info"]}>
              <NextLink href={`/products/${product.itemCode}`} passHref>
                <a>
                  <ReadMore className={styles["readmore-plp-desk"]}>
                    {product.skuName}
                  </ReadMore>
                </a>
              </NextLink>
              <p className={styles["plp-price"]}>
                <NoTranslate>
                  {"$" + intlNumberFormatter.format(product.price)}
                </NoTranslate>
              </p>
            </div>
            <div
              className={styles["plp-card-footer"]}
              // style={
              //   product.hasOwnProperty('pointValue') === false
              //     ? { display: 'block' }
              //     : null
              // }
            >
              <div className={styles["plp-pv-bv"]}>
                {loggedInUserRole === aboUserRoleIdentifier &&
                product.pointValue &&
                product.businessVolume ? (
                  <span>
                    <span>
                      <p>PV:</p>
                      &nbsp;
                      {product.pointValue}
                    </span>
                    <span>
                      <p>BV:</p>
                      &nbsp;
                      {product.businessVolume}
                    </span>
                  </span>
                ) : null}
              </div>
            </div>
          </div>
          {/* ----------VARIANT HANDLER --------------- */}
          <>
            <div className={styles["plp-cta-btns"]}>
              {displayQuantitySelector ? (
                <div className={styles["plp-quantity"]}>
                  <QuantitySelector
                    style={!displayAddToCart && { width: "100%" }}
                    quantity={quantity}
                    minQuantityRule={0}
                    onQuantityChange={onQuantityChange}
                    isOutOfStock={product.isOutOfStock}
                    disableAddToCart={isProductDisabled || disableAddToCart}
                  />
                </div>
              ) : null}
              {displayAddToCart ? (
                <div className={styles["plp-addToCart"]}>
                  <CartBtn
                    style={!displayQuantitySelector && { width: "100%" }}
                    onAddToCart={onAddToCartHandle}
                    isOutOfStock={product.isOutOfStock}
                    disableAddToCart={isProductDisabled || disableAddToCart}
                    cartText={null}
                  />
                </div>
              ) : null}
            </div>
            <div className={styles["plp-cta-btns-desk"]}>
              {displayQuantitySelector ? (
                <div
                  style={!displayAddToCart && { width: "100%" }}
                  className={styles["plp-quantity"]}
                >
                  <QuantitySelector
                    style={!displayAddToCart && { width: "100%" }}
                    quantity={quantity}
                    minQuantityRule={0}
                    onQuantityChange={onQuantityChange}
                    isOutOfStock={product.isOutOfStock}
                    disableAddToCart={isProductDisabled || disableAddToCart}
                  />
                </div>
              ) : null}
              {displayAddToCart ? (
                <div className={styles["plp-addToCart"]}>
                  <CartBtn
                    style={!displayQuantitySelector && { width: "100%" }}
                    onAddToCart={onAddToCartHandle}
                    isOutOfStock={product.isOutOfStock}
                    disableAddToCart={isProductDisabled || disableAddToCart}
                    cartText={cartText}
                  />
                </div>
              ) : null}
            </div>
          </>
        </div>
      </div>
    </div>
  );
}

PromotionCard.defaultProps = {
  selectedProductIds: [],
  disableAddToCart: false,
  selectVariantText: "規格選擇",
  displayAddToCart: true,
  displayQuantitySelector: true,
};

const WishlistedComp = ({ isWishlisted, onWishlistHandle }) =>
  isWishlisted ? (
    <svg
      className={styles["wishlist-icon-svg"]}
      onClick={onWishlistHandle}
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0592 1.19056C15.8696 -0.582132 12.6798 -0.349751 10.7702 1.72156L10.0012 2.51456L9.2312 1.72156C7.32189 -0.35023 4.13163 -0.582639 1.9422 1.19056C0.77929 2.19521 0.0795162 3.633 0.00636526 5.16803C-0.0667856 6.70307 0.493094 8.20088 1.5552 9.31156L9.1132 17.1116C9.34426 17.3527 9.66374 17.489 9.9977 17.489C10.3317 17.489 10.6512 17.3527 10.8822 17.1116L18.4402 9.31156C19.5039 8.20195 20.0652 6.7042 19.9928 5.16881C19.9204 3.63342 19.2206 2.19514 18.0572 1.19056H18.0592Z"
        fill="#2C2C2C"
      />
    </svg>
  ) : (
    <svg
      className={styles["wishlist-icon-svg"]}
      onClick={onWishlistHandle}
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.24 1.93194C12.452 -0.320061 16.024 -0.612061 18.336 1.33194C21.348 3.86794 20.9 7.99594 18.76 10.1839L11.744 17.3319C11.344 17.7399 10.812 17.9639 10.24 17.9639C9.672 17.9639 9.136 17.7359 8.736 17.3279L1.72 10.1799C-0.423995 7.99194 -0.863995 3.86394 2.144 1.33194C4.456 -0.616061 8.028 -0.320061 10.24 1.93194ZM10.376 15.9799L17.392 8.83194C18.84 7.35594 19.144 4.52394 17.1 2.79994C15.552 1.49594 13.152 1.68394 11.64 3.22394L10.24 4.65194L8.84 3.22394C7.336 1.69194 4.936 1.49594 3.38 2.80394C1.332 4.52794 1.628 7.34394 3.088 8.83194L10.104 15.9799C10.2 16.0759 10.28 16.0759 10.376 15.9799Z"
        fill="#2C2C2C"
      />
    </svg>
  );

export default PromotionCard;
